import { render, staticRenderFns } from "./editSign.vue?vue&type=template&id=4d588b10&scoped=true&"
import script from "./editSign.vue?vue&type=script&lang=js&"
export * from "./editSign.vue?vue&type=script&lang=js&"
import style0 from "./editSign.vue?vue&type=style&index=0&id=4d588b10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d588b10",
  null
  
)

export default component.exports